import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ForgotPasswordFormType } from "types";
import { buttonVariants } from "utils/muiTailwindStyles";

interface Props {
  isSubmitting: boolean;
  isValid: boolean;
}

function ForgotPasswordForm({ isSubmitting, isValid }: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext<ForgotPasswordFormType>();

  return (
    <Fragment>
      <Box className="text-center space-y-6">
        <Typography
          variant="h5"
          component="h5"
          className="text-f22 leading-7 text-surface-dark"
        >
          Forgot Password
        </Typography>
        <Box>
          <Typography variant="body2" className="text-black text-base px-4">
            Please enter your email address to reset your password.
          </Typography>
        </Box>
      </Box>
      <Box className="space-y-6">
        <Controller
          name="email"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              className="w-full"
              error={!!errors.email}
              helperText={errors.email?.message}
              {...field}
            />
          )}
        />

        <Button
          type="submit"
          variant="contained"
          className={`${buttonVariants.primary.className} w-full text-base rounded-full py-3 disabled:text-surface-light disabled:opacity-40`}
          sx={{
            ...buttonVariants.primary.sx,
          }}
          disabled={!isValid}
        >
          {isSubmitting ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Send Link"
          )}
        </Button>
      </Box>
    </Fragment>
  );
}

export default ForgotPasswordForm;
